import { BrainApi } from '@src/services/brain/brain-api';
import { TeamMemberItemDTO } from '@src/services/brain/modules/v1/team-members/dto/brain-team-members.get.response.dto';
import { LutienApi } from '@src/services/lutien/lutien-api';

const brainApiClient = new BrainApi();
const lutienClient = new LutienApi();

export const getTeamMembers = async (): Promise<Array<TeamMemberItemDTO>> => {
  const teamMembers = await brainApiClient.v1.teamMembers.get({ params: { paginate: false } });
  return teamMembers.items;
};

export const getUsersNames = async (
  ids: string[],
  alreadySetUsers: Record<string, string> = {},
): Promise<Record<string, string>> => {
  const userNames: Record<string, string> = { ...alreadySetUsers };

  const userIdsToFetch = ids.filter((id) => id && !userNames[id]);

  if (userIdsToFetch.length === 0) {
    return Promise.resolve(userNames);
  }

  const uniqueUserIdsToFetch = [...new Set(userIdsToFetch)];

  const usersPromises = uniqueUserIdsToFetch.map((id) => lutienClient.v1.users.getById({ id }));

  const users = await Promise.all(usersPromises);

  users.forEach((user) => {
    userNames[user.id] = `${user.name} ${user.lastName ?? ''}`.trim();
  });

  return userNames;
};
